module.exports = __webpack_public_path__ + "static/media/bye2.45fabdf5.gif";